export default __webpack_public_path__ + "6c77a12a7095f7b06619766e2c4bb05c.png";